var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49707 6C9.49707 7.65685 8.15392 9 6.49707 9C4.84022 9 3.49707 7.65685 3.49707 6C3.49707 4.34315 4.84022 3 6.49707 3C8.15392 3 9.49707 4.34315 9.49707 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4971 6C17.4971 7.65685 16.1539 9 14.4971 9C12.8402 9 11.4971 7.65685 11.4971 6C11.4971 4.34315 12.8402 3 14.4971 3C16.1539 3 17.4971 4.34315 17.4971 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4262 17C13.4729 16.6734 13.4971 16.3395 13.4971 16C13.4971 14.3648 12.9364 12.8606 11.9968 11.6691C12.7323 11.2435 13.5863 11 14.4971 11C17.2585 11 19.4971 13.2386 19.4971 16V17H13.4262Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49707 11C9.25849 11 11.4971 13.2386 11.4971 16V17H1.49707V16C1.49707 13.2386 3.73565 11 6.49707 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLite);
export default __webpack_public_path__ + "static/media/UserLite.3ee6d9f783025e1b79068b94da698e14.svg";
export { ForwardRef as ReactComponent };